const READ_ONLY_BOOKING_STATUSES = ["cancelled", "noshow"];

export const isReadOnlyBookingStatus = (status) =>
  READ_ONLY_BOOKING_STATUSES.includes(
    String(status || "").toLowerCase().replace(/[^a-z]/g, "")
  );

export const getBookingPreventChanges = (editableBooking) => {
    const paymentStatus =
      editableBooking?.sale?.payment_status?.toLowerCase() || "";
  
    const isBookingCompleted = paymentStatus === "closed";
    const isBookingPaymentInProgress =
      paymentStatus === "open(in progress)";
    const isBookingStatusReadOnly = isReadOnlyBookingStatus(editableBooking?.status);
  
    return {
      paymentStatus,
      isBookingCompleted,
      isBookingPaymentInProgress,
      isBookingStatusReadOnly,
      preventChanges:
        isBookingCompleted || isBookingPaymentInProgress || isBookingStatusReadOnly,
    };
  };
